import FeatureLayer from "@arcgis/core/layers/FeatureLayer";
import { GetCodedValueAndAlias, getMapView } from "../../../utils/arcgisUtils";
import { formatDate } from "../../../utils/helpers";

import "./ChangedField.css";
import { FeatureObject } from "../../../utils/newVersioningUtils";
import { useState } from "react";
import ArrowIcon from "../../../assets/arrow-back.svg?react";

interface ChangedFieldProps {
    editedFeature: FeatureObject;
    field: string;
    fromOperative: boolean;
    showAsFromTo?: boolean;
}

const ChangedField = (props: ChangedFieldProps) => {
    const [layer, setLayer] = useState<FeatureLayer | null>(null);

    const getLayer = () => {
        if (layer) {
            return layer;
        }
        let tempLayer = props.editedFeature.versionGraphic?.layer;

        tempLayer ??= props.editedFeature.defaultGraphic?.layer;

        if (!tempLayer) {
            const mapView = getMapView();
            if (mapView?.map) {
                let allLayers = mapView.map.allLayers.toArray();
                allLayers = allLayers.concat(mapView.map.allTables.toArray());
                allLayers.forEach((l) => {
                    if (l.type === "feature") {
                        if ((l as FeatureLayer).layerId === props.editedFeature.layerId) {
                            tempLayer = l;
                        }
                    }
                });
            }
        }
        setLayer((tempLayer as FeatureLayer) ?? null);
        return tempLayer;
    };

    const formatFieldName = () => {
        const layer = getLayer();

        if (!layer) {
            return props.field;
        }

        const fieldName = GetCodedValueAndAlias(layer, props.field, "");
        return fieldName[0];
    };

    const formatFieldValue = (original: boolean) => {
        const layer = getLayer();

        if (!layer) {
            return props.field;
        }

        let fieldValue;

        if (original) {
            if (props.fromOperative) {
                fieldValue = GetCodedValueAndAlias(
                    layer,
                    props.field,
                    props.editedFeature.operativeGraphic?.attributes[props.field]
                );
            } else {
                fieldValue = GetCodedValueAndAlias(
                    layer,
                    props.field,
                    props.editedFeature.defaultGraphic?.attributes[props.field]
                );
            }
        } else {
            fieldValue = GetCodedValueAndAlias(
                layer,
                props.field,
                props.editedFeature.versionGraphic?.attributes[props.field]
            );
        }

        if (!fieldValue) {
            return null;
        }

        if ((layer as FeatureLayer).fields?.find((fld) => fld.name === props.field)?.type === "date") {
            return formatDate(fieldValue[1] as number, true);
        }

        return fieldValue[1];
    };

    // if (props.editedFeature.versionGraphic?.attributes[props.field] === undefined || props.editedFeature.versionGraphic?.attributes[props.field] === null) {
    //     return null;
    // }
    if (
        !props.fromOperative &&
        props.editedFeature.defaultGraphic?.attributes[props.field] ===
            props.editedFeature.versionGraphic?.attributes[props.field]
    ) {
        return null;
    }

    if (
        !props.fromOperative &&
        (props.editedFeature.defaultGraphic?.attributes[props.field] === null ||
            props.editedFeature.defaultGraphic?.attributes[props.field] === undefined) &&
        (props.editedFeature.versionGraphic?.attributes[props.field] === null ||
            props.editedFeature.versionGraphic?.attributes[props.field] === undefined)
    ) {
        return null;
    }

    if (["objectid", "globalid"].includes(props.field)) {
        return null;
    }

    if (
        props.fromOperative &&
        (props.editedFeature.operativeGraphic?.attributes[props.field] === null ||
            props.editedFeature.operativeGraphic?.attributes[props.field] === undefined) &&
        (props.editedFeature.versionGraphic?.attributes[props.field] === null ||
            props.editedFeature.versionGraphic?.attributes[props.field] === undefined)
    ) {
        return null;
    }

    return (
        <div className={`${props.showAsFromTo ? "flex-row" : "flex-col"} w-100 space-between`}>
            <span className="changed-field">{formatFieldName()}: </span>
            {props.editedFeature.type === "insert" && (
                <span className="changed-field-new-value w-100">{formatFieldValue(false)}</span>
            )}
            {props.editedFeature.type === "update" && !props.showAsFromTo && (
                <span className="flex-col w-100">
                    <span className="changed-field-new-value">{formatFieldValue(false)}</span>
                    <span className="changed-field-old-value">{formatFieldValue(true)}</span>
                </span>
            )}
            {props.editedFeature.type === "update" && props.showAsFromTo && (
                <span className="flex-row">
                    <span className="changed-field-old-value changed-field-from-to">{formatFieldValue(false)}</span>
                    <ArrowIcon style={{ rotate: "180deg", marginLeft: "0.5rem", marginRight: "0.5rem" }} />
                    <span className="changed-field-new-value changed-field-from-to">{formatFieldValue(true)}</span>
                </span>
            )}
        </div>
    );
};

export default ChangedField;
